export default {
  data() {

    return {

    }
  },
  mounted() {},
  methods: {

    tableHeaderColor({
      row,
      column,
      rowIndex,
      columnIndex
    }) {
      if (rowIndex === 0) {
        return "font-weight:bold;text-align:center;padding:0px 0;color:#d3bd8e;background-color:#fff;";
      }
    },
    tableCellStyle({
      row,
      column,
      rowIndex,
      columnIndex
    }) {
      return "text-align:center;padding:0px 0;";
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/recruit/tableBaseCss.js